<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-text-field
          v-model="filtroNome"
          label="Buscar por nome"
          prepend-icon="mdi-magnify"
          class="mb-4"
          clearable
        />
        <v-spacer />
        <!-- <v-btn color="primary" @click="adicionarPessoa">Adicionar Novo</v-btn> -->
      </v-card-title>

      <v-card-text>
        <div v-for="(pessoa, index) in pessoasFiltradas" :key="index" class="mb-8">
          <v-card class="pa-4">
            <v-tabs v-model="abas[index]" background-color="primary" dark grow>
              <v-tab>Matrícula</v-tab>
              <v-tab>Tipo de Atendimento especializado</v-tab>
              <v-tab>Transporte</v-tab>
            </v-tabs>

            <v-tabs-items v-model="abas[index]">
              <v-tab-item>
                <v-row class="mt-5">
                  <v-col cols="12">
                    <e-autocomplete
                      :items="turmasCenso20"
                      :return-object="false"
                      :item-value="(value) => value.turma.descricao"
                      :item-text="(val) => `${val.turma.descricao}`"
                      v-model="pessoa.nome_turma"
                      label="Selecione uma turma"
                      dense
                      solo
                    />
                  </v-col>

                  <v-col cols="4">
                    <e-autocomplete
                      :items="alunosCenso30"
                      :return-object="false"
                      :item-value="(value) => value.codigo_pessoa_fisica_sistema"
                      :item-text="
                        (val) =>
                          `${val.codigo_pessoa_fisica_sistema} - ${val.matricula.aluno.nomecompleto}`
                      "
                      v-model="pessoa.cod_pessoa_fisica_sistema"
                      label="Selecione um aluno"
                      dense
                      solo
                    />
                  </v-col>
                  <v-col cols="4">
                    <e-autocomplete
                      :items="$constants.etapasList"
                      :return-object="false"
                      :item-value="(value) => value.codigoEtapaEnsino"
                      :item-text="(val) => `${val.codigoEtapaEnsino} - ${val.nomeEtapaEnsino}`"
                      v-model="pessoa.etapa"
                      label="Selecione uma Etapa"
                      dense
                      solo
                    />
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item>
                <v-row>
                  <v-col cols="12">
                    <h4>Tipo de atendimento educacional especializado</h4>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.desenvol_funco_cognitivas"
                      label="Desenvolvimento de funções cognitivas"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.desenvol_vida_autonoma"
                      label="Desenvolvimento de vida autônoma"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.enriquecimento_curricular"
                      label="Enriquecimento curricular"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.ensino_informatica_acessivel"
                      label="Ensino da informática acessível"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.ensino_libras"
                      label="Ensino da Língua Brasileira de Sinais (Libras)"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.ensino_ling_portugues_segunda"
                      label="Ensino da Língua Portuguesa como Segunda Língua"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.ensino_tec_calculo"
                      label="Ensino das técnicas do cálculo no Soroban"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.ensino_braile"
                      label="Ensino de Sistema Braille"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.ensino_tec_mobilidade"
                      label="Ensino de técnicas para orientação e mobilidade"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.ensino_caa"
                      label="Ensino de uso da Comunicação Alternativa e Aumentativa (CAA)"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.ensino_opticos_nao_opticos"
                      label="Ensino de uso de recursos ópticos e não ópticos"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      :items="[
                        ' 1 – Não recebe escolarização fora da escola',
                        '2 – Em hospital',
                        '3 – Em domicílio',
                      ]"
                      v-model="pessoa.recebe_esc_espaco_diferente"
                      label="Recebe escolarização em outro espaço (diferente da escola)"
                      dense
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row>
                  <v-col cols="12">
                    <h4>Tipo de veículo utilizado no transporte escolar público</h4>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.transporte_publico"
                      label="Transporte escolar público"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-select
                      :items="['1 - Estadual', '2 - Municipal']"
                      v-model="pessoa.resp_transporte_publico"
                      label="Poder Público responsável pelo transporte escolar"
                      dense
                      solo
                    ></v-select>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.bicicleta"
                      label="Rodoviário - Bicicleta"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.microonibus"
                      label="Rodoviário - Microônibus"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.onibus"
                      label="Rodoviário - Ônibus"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.tracao_animal"
                      label="Rodoviário - Tração animal"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.vans"
                      label="Rodoviário - Vans/KOMBIS"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.outro"
                      label="Rodoviário - Outro"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.aquaviario_5_alunos"
                      label="Aquaviário - Capacidade de até 5 aluno(a)s"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.aquaviario_15_alunos"
                      label="Aquaviário - Capacidade de 5 a 15 aluno(a)s"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.aquaviario_35_alunos"
                      label="Aquaviário -  Capacidade de 15 a 35 aluno(a)s"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                  <v-col cols="4">
                    <v-checkbox
                      v-model="pessoa.aquaviario_maior_35_alunos"
                      label="Aquaviário -  Capacidade de mais de 35 aluno(a)s"
                      dense
                      solo
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </div>
        <v-row justify="center" class="my-4">
          <v-btn @click="prevPage" :disabled="currentPage === 1" class="mx-2">← Anterior</v-btn>
          <v-btn @click="nextPage" :disabled="currentPage === totalPages" class="mx-2"
            >Próximo →</v-btn
          >
        </v-row>
        <v-row class="mt-4">
          <v-col cols="6">
            <v-btn block color="error" @click="submitForm('prev')">
              <v-icon>mdi-chevron-left</v-icon> Etapa Anterior</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn block color="success" @click="submitForm('next')">
              <v-icon>mdi-chevron-right</v-icon> Gerar Arquivo (.txt)</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  computed: {
    pessoasFiltradas() {
      if (!this.filtroNome) return this.pessoas;
      return this.pessoas.filter(
        (p) =>
          p.nomecompleto && p.nomecompleto.toLowerCase().includes(this.filtroNome.toLowerCase())
      );
    },
  },
  data() {
    return {
      totalPages: 1,
      filtroNome: "",
      emailRule: (v) => /.+@.+\..+/.test(v) || "E-mail inválido",
      pessoas: [],
      currentPage: 1,
      itemsPerPage: 10,
      abas: [0],
      binarios: ["0", "1"],
      sexos: ["1 - Masculino", "2 - Feminino", "3 - Outro"],
      cores: [
        "0 - Não Declarada",
        "1 - Branca",
        "2 - Preta",
        "3 - Parda",
        "4 - Amarela",
        "5 - Indígena",
      ],
      nacionalidades: [
        "1 - Brasileira",
        "2 - Brasileira - nascido no Exterior ou Naturalizado",
        "3 - Estrangeira",
      ],
      menu: false,
      deficiencias: [
        "cegueira",
        "baixa_visao",
        "visao_monocular",
        "surdez",
        "deficiencia_auditiva",
        "surdocegueira",
        "deficiencia_fisica",
        "deficiencia_intelectual",
        "deficiencia_multipla",
        "transtorno_espectro_autista",
        "altas_habilidades_superdotacao",
        "transtornos_aprendizagem",
        "discalculia",
        "disgrafia_disortografia",
        "dislalia",
        "dislexia",
        "tdah",
        "tpac",
      ],
      recursos: [
        "auxilio_ledor",
        "auxilio_transcricao",
        "guia_interprete",
        "tradutor_interprete_libras",
        "leitura_labial",
        "prova_ampliada",
        "prova_super_ampliada",
        "cd_audio",
        "prova_lingua_portuguesa",
        "prova_video_libras",
        "material_didatico_braille",
        "prova_em_braille",
        "tempo_adicional",
        "nenhum_recurso",
        "",
      ],
      municipiosNasc: [],
      municipiosRes: [],
      alunosCenso30: [],
      turmasCenso20: [],
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    filtroNome() {
      this.currentPage = 1;
      this.getData(1);
    },
    currentPage(newPage) {
      this.getData(newPage);
    },
  },
  methods: {
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },

    async getData(page = 1) {
      this.$loaderService.open("Carregando...");
      try {
        const params = {
          page,
          per_page: this.itemsPerPage,
        };

        const res = await this.$services.censoService.getPaginatedData60(params);

        this.pessoas = res.data;
        this.totalPages = res.last_page;
        this.currentPage = res.current_page;
        this.alunosCenso30 = res.alunos;
        this.turmasCenso20 = res.turmas;
      } catch (error) {
        this.$toast.error(error.message);
      } finally {
        this.$loaderService.close();
      }
    },
    async pesquisarCep(cep) {
      // if (cep.length === 9) {
      //   const cepData = await this.$services.cepService.buscarDadosDoCep(cep);
      //   this.formData.cep = cepData.cep;
      //   this.formData.logradouro = cepData.rua;
      //   this.formData.bairro = cepData.bairro;
      //   this.formData.codigo_municipio = cepData.cidade;
      // }
    },
    atualizarEstado(value) {
      if (value) {
        this.municipiosNasc = this.$constants.municipios[value].cidades;
      }
    },

    atualizarEstadoRes(value) {
      if (value) {
        this.municipiosRes = this.$constants.municipios[value].cidades;
      }
    },
    adicionarPessoa() {
      this.pessoas.push({});
      this.abas.push(0);
    },
    removerPessoa(index) {
      this.pessoas.splice(index, 1);
      this.abas.splice(index, 1);
    },

    async submitForm(type) {
      try {
        await this.$services.censoService.saveData(this.pessoas, "aba60");
        if (type === "next") {
          this.$emit("event", "tab-8");
        } else {
          this.$emit("event", "tab-6");
        }
      } catch (error) {
        this.$handleError(error);
      }
    },

    formatarCampo(campo) {
      return campo.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
    },
  },
};
</script>

<style scoped>
.v-card {
  border: 1px solid #ccc;
}
</style>
